import {
  GraphQL,
  CompositeFilter,
  Filter,
  FilterValue,
  SimpleFilter,
  ValueFilter,
} from '@/serverSideTable/materializedTables/materializedTables.constants';

export function composeFilters(
  operation: string,
  filter: Filter,
  ...filters: (Filter | null)[]
): Filter | CompositeFilter {
  const validFilters = filters.filter((filter) => filter) as Filter[];
  if (validFilters.length === 0) {
    return filter;
  } else if (validFilters.length === 1) {
    return { compositeFilter: { operation, filter1: filter, filter2: validFilters[0] } };
  } else {
    return validFilters.reduce(
      (compositeFilter, newFilter) => composeFilters(operation, compositeFilter, newFilter),
      filter,
    );
  }
}

export function andFilters(filter: Filter, ...filters: (Filter | null)[]): Filter | CompositeFilter {
  return composeFilters(GraphQL.Operations.And, filter, ...filters);
}

export function orFilters(filter: Filter, ...filters: (Filter | null)[]): Filter | CompositeFilter {
  return composeFilters(GraphQL.Operations.Or, filter, ...filters);
}

export function valueFilter(columnName: string, filterType: string, value: FilterValue | FilterValue[]): ValueFilter {
  return { valueFilter: { columnName, filterType, value } };
}

export function simpleFilter(columnName: string, filterType: string): SimpleFilter {
  return { simpleFilter: { columnName, filterType } };
}

export function isNull(columnName: string): SimpleFilter {
  return simpleFilter(columnName, GraphQL.FilterTypes.IsNull);
}

export function isNotNull(columnName: string): SimpleFilter {
  return simpleFilter(columnName, GraphQL.FilterTypes.IsNotNull);
}

export function notEqual(columnName: string, value: FilterValue): ValueFilter {
  return valueFilter(columnName, GraphQL.FilterTypes.NotIn, [value]);
}

export function equal(columnName: string, value: FilterValue): ValueFilter {
  return valueFilter(columnName, GraphQL.FilterTypes.In, [value]);
}
